var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cross"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.9608 3.96073L12.0001 12",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.96087 12L12.0001 3.96073",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeClose);
export default __webpack_public_path__ + "static/media/badge-close.5b1840ceccf7cba7e2c8f0db5430b9a7.svg";
export { ForwardRef as ReactComponent };